import React, { createContext, useContext, useEffect } from "react";
import { useHttpRequest } from "./HttpRequest";
import { HTTP_METHODS } from "src/config/constants";
import axios from "axios";

const BSMProjectContext = createContext();

const BsmProjectProvider = ({ children }) => {
  const { isLoading, error, sendRequest, clearError } = useHttpRequest();
  const token = localStorage.getItem("token");


  const getProjectList = async (requestBody) => {
    // console.log("On getProjectList");

    const headers = {
      "Content-Type": "application/json",
    };

    const responseData = await sendRequest(
      `/project/list`,
      HTTP_METHODS.POST,
      headers,
      requestBody
    );
    return responseData;
  };

  const createNewProject = async (data) => {
    console.log("On createNewProject", data);
    const headers = { "Content-Type": "application/json" };

    const requestBody = {
      companyCode: data.companyCode,
      projectCode: data.projectCode,
      projectName: data.projectName,
      planCode: "BASIC",
      projectAdminUsername: data.projectAdminUsername,
      projectAdminPassword: data.projectAdminPassword,
    }

    const responseData = await sendRequest(
      "/project",
      HTTP_METHODS.POST,
      headers,
      requestBody
    );
    return responseData;
  };

  const getProject = async (project_id) => {
    console.log("On getProject");
    const headers = { "Content-Type": "application/json", };

    const responseData = await sendRequest(
      `/project/${project_id}`,
      HTTP_METHODS.GET,
      headers
    );
    console.log(responseData);
    return responseData;
  };

  const updateProject = async (project_id, data) => {
    // console.log(project_id, requestBody, "vvv");
    // console.log("On updateProject");
    const headers = { "Content-Type": "application/json" };

    const requestBody = {
      projectName: data.projectName,
      projectNameCN: data.projectNameCN,
      ownerLicense: data.ownerLicense,
      userLicense: data.userLicense,
      expiryDate: data.expiryDate,
      planCode: data.projectPlan,
      address: data.address,
      building: data.building,
      latitude: data.latitude,
      longitude: data.longitude,
    }

    const responseData = await sendRequest(
      `/project/${project_id}`,
      HTTP_METHODS.PUT,
      headers,
      requestBody
    );
    console.log(responseData, "dddd");
    return responseData;
  };

  const uploadProjectIcon = async (project_id, data) => {
    console.log("On uploadProjectIcon");
    const headers = {};

    const formData = new FormData();
    formData.append("file", data.iconName[0]);

    const responseData = await sendRequest(
      `/project/${project_id}/upload/icon`,
      HTTP_METHODS.PUT,
      headers,
      formData
    );
    console.log(responseData);
    return responseData;
  };

  const uploadProjectVideo = async (project_id, data) => {
    console.log("On uploadProjectVideo");
    const headers = {};

    const formData = new FormData();
    formData.append("file", data.videoName[0]);

    const responseData = await sendRequest(
      `/project/${project_id}/upload/video`,
      HTTP_METHODS.PUT,
      headers,
      formData
    );
    console.log(responseData);
    return responseData;
  };

  const deleteProjectIcon = async (project_id) => {
    console.log("On deleteProjectIcon");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/upload/icon`,
      HTTP_METHODS.DELETE,
      headers
    );
    console.log(responseData);
    return responseData;
  };

  const deleteProjectVideo = async (project_id) => {
    console.log("On deleteProjectVideo");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/upload/video`,
      HTTP_METHODS.DELETE,
      headers
    );
    console.log(responseData);
    return responseData;
  };

  const inactiveProject = async (project_id) => {
    console.log("On inactiveProject");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/inactive`,
      HTTP_METHODS.PUT,
      headers
    );
    console.log(responseData);
    return responseData;
  };

  const activeProject = async (project_id) => {
    console.log("On activeProject");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/active`,
      HTTP_METHODS.PUT,
      headers
    );
    console.log(responseData);
    return responseData;
  };

  const assignProjectUser = async (project_id, requestBody) => {
    console.log("On assignProjectUser");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/assign/user`,
      HTTP_METHODS.PUT,
      headers,
      requestBody
    );
    console.log(responseData);
    return responseData;
  };

  const unassignProjectUser = async (project_id, requestBody) => {
    console.log("On unassignProjectUser");
    const headers = {};

    const responseData = await sendRequest(
      `/project/${project_id}/unassign/user`,
      HTTP_METHODS.PUT,
      headers,
      requestBody
    );
    console.log(responseData);
    return responseData;
  };

  useEffect(() => { }, []);

  return (
    <BSMProjectContext.Provider
      value={{
        isLoading,
        error,
        clearError,
        getProjectList,
        createNewProject,
        getProject,
        updateProject,
        uploadProjectIcon,
        uploadProjectVideo,
        deleteProjectIcon,
        deleteProjectVideo,
        inactiveProject,
        activeProject,
        assignProjectUser,
        unassignProjectUser,
      }}
    >
      {children}
    </BSMProjectContext.Provider>
  );
};

const useBsm = () => {
  const bsmContext = useContext(BSMProjectContext);
  return bsmContext;
};

export { BsmProjectProvider, useBsm };
